import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { toast } from '@/components/ui/sonner';
import { generateNextSwissRound } from '@/data/next-swiss-round';
import type { Match, Tournament } from '@/data/types';

interface Props {
  tournament: Tournament;
  matches: Match[];
}

export function SwissControls({ tournament, matches }: Props) {
  const [busy, setBusy] = useState(false);
  if (tournament.format !== 'SWISS' || tournament.status !== 'IN_PROGRESS') {
    return null;
  }

  const lastRound = matches.length > 0 ? Math.max(...matches.map((m) => m.round)) : 0;
  const incomplete = matches.filter((m) => m.round === lastRound && m.status !== 'COMPLETED').length;
  const totalRounds = tournament.swissRounds ?? 0;
  const allDone = lastRound >= totalRounds && incomplete === 0;

  if (allDone) return null;

  const canGenerate = incomplete === 0 && lastRound < totalRounds;

  async function handleClick() {
    setBusy(true);
    try {
      await generateNextSwissRound(tournament);
      toast.success('Следующий тур сгенерирован');
    } catch (err) {
      toast.error('Не получилось', { description: String((err as Error).message) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="card-d row"
      style={{ padding: 14, justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}
    >
      <div>
        <div style={{ fontWeight: 500 }}>
          Тур {lastRound} из {totalRounds}
        </div>
        {incomplete > 0 && (
          <div className="t-small t-mute">Осталось доиграть: {incomplete}</div>
        )}
      </div>
      <button
        className="btn btn-primary btn-sm"
        onClick={handleClick}
        disabled={!canGenerate || busy}
      >
        {busy ? (
          <>
            <span className="spinner" /> Генерируем...
          </>
        ) : (
          <>
            <Sparkles size={14} /> Сгенерировать тур {lastRound + 1}
          </>
        )}
      </button>
    </div>
  );
}
